import { Container } from '../../../../../../../../components/container/container';
import { Select } from '../../../../../../../../components/select/select';
import { MenuInformerCreateUnit } from '../../menu-informer-table-header/menu-informer-create-unit';
import s from './menu-informer-create-dish-modal-step-2.module.css';
import { useMenuInformerCreateDishModalStep2 } from './use-menu-informer-create-dish-modal-step-2';

export const MenuInformerCreateDishModalStep2 = () => {
  const {
    t,
    handleConfirmSection,
    isLoadingSection,
    handleConfirmCategory,
    isLoadingCategory,
    selectedSection,
    categoryIdValues,
    sectionIdValues,
    selectedCategory,
    handleSelectSection,
    handleSelectCategory,
  } = useMenuInformerCreateDishModalStep2();

  return (
    <div className={s.feature}>
      <Container label={t('Раздел')} required>
        <Select
          options={sectionIdValues}
          value={selectedSection}
          onSelect={handleSelectSection}
          name="section"
          data-testid="section-input"
        />
      </Container>

      {!selectedSection?.id && (
        <MenuInformerCreateUnit
          placeholder={t('Название раздела')}
          isLoading={isLoadingSection}
          onConfirm={(e) => handleConfirmSection(selectedSection?.id, e)}
          data-testid="section-name"
        />
      )}
      <Container label={t('Категория')} required>
        <Select
          options={categoryIdValues}
          value={selectedCategory}
          disabled={!selectedSection?.id}
          onSelect={handleSelectCategory}
          name="category"
          data-testid="category-input"
        />
      </Container>

      {!selectedCategory?.id && (
        <MenuInformerCreateUnit
          placeholder={t('Название категории')}
          isLoading={isLoadingCategory}
          onConfirm={(e) => handleConfirmCategory(selectedCategory?.id, e)}
          data-testid="category-name"
        />
      )}
    </div>
  );
};
